import React from "react";
import ProductContainer from "../components/homepage/ProductContainer";
import ProductInputForm from "../components/homepage/ProductInputForm";
import ProductWrapper from "../components/homepage/ProductWrapper";
import Main from "../components/Main";

export default function Home() {
  return (
    <>
      <Main>
        <ProductWrapper>
          <ProductContainer />
          <ProductInputForm />
        </ProductWrapper>
      </Main>
    </>
  );
}
